module.exports = __webpack_public_path__ + "img/strategic-action-section-image.bd870643.png";